import { FC, useMemo } from 'react';
import { $CurrentExperienceAnswerAsAvailable, $CurrentExperienceAnswerFold } from '../../shared/atoms';
import { useAtomValue } from 'jotai';
import { ScopedProvider } from '@lemon8/web-app-shared/ssr';
import { ExperienceMainInfo } from '../experience-main-info';
import { AIOverviewInfo } from '../../shared/component/ai-overview-info';
import { ExperienceSourceArticleList } from '../experience-source-article-list';
import { $UserAgent } from '@lemon8/web-app-shared/atom';

export const ExperienceMainSections: FC = () => {
  const { answerContent, isNewType } = useAtomValue($CurrentExperienceAnswerAsAvailable);
  const { isBot } = useAtomValue($UserAgent);
  const initialFoldState = useMemo(() => {
    return isNewType || answerContent.length >= 2;
  }, [answerContent, isNewType]);

  return (
    <div className="experience-main-section">
      {!isBot && <AIOverviewInfo />}
      <ScopedProvider atomsWithHydration={[[$CurrentExperienceAnswerFold, initialFoldState]]}>
        <ExperienceMainInfo />
      </ScopedProvider>
      {!isBot && <ExperienceSourceArticleList />}
    </div>
  );
};
